import LightBlueEye from "../../components/assets/eyes/LightBlueEye";
import YellowEye from "../../components/assets/eyes/YellowEye";
import Quote from "../../components/assets/Quote";
import Heading from "../../components/layout/Heading";
import WordsAutoSlider from "../../components/layout/WordsAutoSlider";
import DoubleArrowBackground from "../DoubleArrowBackground";

export default function About() {
    return (
        <>
            <div className="w-full max-w-[1470px] mx-auto min-h-[390px] flex flex-col justify-center mobile:px-8">
                <div className="w-full relative py-16 mobile:py-32">
                    <Heading
                        title="Mais en vrai, Zœil c’est quoi ?"
                        subtitle="On va pas te donner notre recette secrète mais plutôt te dire un peu comment on voit notre agence. Allez, c’est déjà pas mal !"
                        highlighted_words={["Zœil"]} />
                    <div className="w-[6.25rem] absolute right-0 top-0 -rotate-[180deg]">
                        <YellowEye />
                    </div>
                    <div className="w-[6.25rem] absolute left-0 bottom-0 rotate-[120deg]">
                        <LightBlueEye />
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center w-full max-w-[1656px] mx-auto min-h-[615px] my-16 px-6 tablet:flex-col-reverse tablet:gap-16">
                <div className="basis-1/2 flex flex-col gap-[3.4375rem] pr-32 tablet:pr-0">
                    <h2 className="font-bold text-heading-2 leading-[100%] mobile:text-heading-3">
                        Juste deux potes qui kiff la comm’ digitale ?
                    </h2>
                    <div className="flex flex-col gap-6">
                        <p>
                            On est deux potes avec une obsession commune : sortir du cadre, voir plus loin que ce qu’on nous propose, et surtout, ne jamais s’ennuyer. Après avoir testé un paquet de chemins (on vous épargne la liste interminable), on a réalisé que notre kiff ultime, c’était la création. Et c’est là que ZOEIL est né. C’est notre bébé, notre projet pour mettre un coup de pied dans la routine et exploser les limites. Ici, on s’amuse à mixer les concepts, à jouer avec les visuels et à créer des projets qui déchirent. Mais attention, on reste sérieux (quand il faut). Ce qu’on aime par-dessus tout, c’est garder cette authenticité, ce grain de folie qui nous pousse à toujours voir plus grand. Parce qu’au fond, on le fait avec passion, et c’est là que la magie opère.
                        </p>
                        <p>
                            Aujourd'hui, ZOEIL, c'est aussi l’histoire d’une vraie complicité. On se complète à la perfection, chacun avec ses forces et ses petites manies. Là où l’un a l’œil sur les détails, l’autre voit plus grand, et c’est ce qui fait qu’on se pousse constamment à aller plus loin. Pas besoin de parler pendant des heures, un regard suffit souvent pour se comprendre et capter où on veut aller. On bosse toujours en duo, on échange sans arrêt pour se challenger et tirer le meilleur de nous-mêmes. C’est comme ça qu’on arrive à créer des projets qui nous ressemblent et qui, surtout, vous marquent.
                        </p>
                    </div>
                </div>
                <div className="basis-1/2">
                    <img src="https://zoeil.yanisallali.com/wp-content/uploads/2024/10/about_photo.png" alt="" className="w-full max-h-[615px] object-cover tablet:max-h-[300px]" />
                </div>
            </div>
            <WordsAutoSlider
            words={[
                "Fun",
                "Créativité",
                "Authenticité"
            ]}/>
            <div className="w-fit flex justify-center mx-auto gap-[4.875rem] py-32 px-6 tablet:flex-col mobile:pb-0">
                <Quote
                text="Apprendre, Créer, Partager !"
                author="Yanis"/>
                <Quote
                text="Viens on monte une boîte ensemble ?"
                author="Logan"/>
            </div>
            <DoubleArrowBackground></DoubleArrowBackground>
        </>
    )
}